<!-- old listing template, not used anymore -->
<ng-container *ngIf="false">
  <div class="listing-placeholder">
    <div class="listing-placeholder__images">
      <div class="listing-placeholder__images-item">
        <span class="placeholder-text placeholder-text--listing-image"></span>
      </div>
      <div class="listing-placeholder__images-item">
        <span class="placeholder-text placeholder-text--listing-image"></span>
      </div>
    </div>
    <span class="placeholder-text placeholder-text--listing-item-title"></span>
    <div class="listing-placeholder__info">
      <span class="placeholder-text placeholder-text--listing-info"></span>
    </div>
    <span class="placeholder-text placeholder-text--button placeholder-text--listing-btn"></span>
  </div>
</ng-container>

<!-- new listing cards design -->
<ng-container *ngIf="type === placeholderTypes.listing">
  <div *ngFor="let item of [1, 2, 3]" class="listing-placeholder--card-new">
    <div class="listing-placeholder__gallery">
      <div class="gallery__images placeholder-text placeholder-text--listing-image"></div>
    </div>
    <div class="listing-placeholder__inner">
      <div class="inner__info">
        <div class="info-title placeholder-text placeholder-text--listing-item-title"></div>
        <div class="info-review-widget placeholder-text placeholder-text--listing-item-title"></div>
      </div>
      <div class="inner__description">
        <div class="description-item placeholder-text placeholder-text--listing-info"></div>
        <div class="description-item placeholder-text placeholder-text--listing-info"></div>
        <div class="description-item placeholder-text placeholder-text--listing-info"></div>
      </div>
      <div class="inner__price-link">
        <div class="price-link-button placeholder-text placeholder-text--button placeholder-text--listing-btn"></div>
      </div>
    </div>
  </div>
</ng-container>

<!-- new listing cards design -->
<ng-container *ngIf="type === placeholderTypes.listingMap">
  <div class="placeholder-text placeholder-text--listing-map"></div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bookingTotal">
  <div *ngFor="let item of loopArray; let i = index" class="booking-total-placeholder">
    <span class="booking-total-placeholder__item">
      <span class="placeholder-text placeholder-text--booking-total"></span>
    </span>
    <span class="booking-total-placeholder__item">
      <span class="placeholder-text placeholder-text--booking-total"></span>
    </span>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdp">
  <div class="pdp-placeholder">
    <span class="placeholder-text placeholder-text--pdp-item-title"></span>
    <span class="placeholder-text placeholder-text--pdp-item-address"></span>
    <div>
      <span class="placeholder-text placeholder-text--pdp-item-description"></span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpMobile">
  <div class="pdp-placeholder">
    <span class="placeholder-text placeholder-text--pdp-item-title"></span>
    <span class="placeholder-text placeholder-text--pdp-item-address"></span>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpOfferMobile">
  <div class="pdp-offer-placeholder">
    <span class="placeholder-text placeholder-text--pdp-offer-item-title"></span>
    <div class="pdp-offer-placeholder__gallery">
      <span class="placeholder-text placeholder-text--pdp-offer-item-img"></span>
    </div>
    <span class="placeholder-text placeholder-text--pdp-offer-item-places"></span>

    <span *ngFor="let item of [1, 2]" class="placeholder-text"></span>

    <div class="pdp-offer-placeholder__bottom">
      <span class="placeholder-text placeholder-text--pdp-prices"></span>
      <span class="placeholder-text placeholder-text--button placeholder-text--pdp-btn"></span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpOfferPriceLoadingMobile">
  <div class="pdp-offer-placeholder pdp-price-placeholder--mobile">
    <div class="pdp-offer-placeholder__content-second">
      <div>
        <span class="placeholder-text pdp-price-placeholder__content-second-text-1"></span>
        <span class="placeholder-text pdp-price-placeholder__content-second-text-2"></span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpOfferMobileRedesigned">
  <div class="pdp-offer-placeholder">
    <span class="placeholder-text placeholder-text--pdp-offer-item-title"></span>
    <div class="pdp-offer-placeholder__gallery-redesigned">
      <span class="placeholder-text placeholder-text--pdp-offer-item-img-redesigned"></span>
    </div>
    <span class="placeholder-text placeholder-text--pdp-offer-item-places"></span>
    <div class="pdp-offer-placeholder__rates">
      <span *ngFor="let item of [1, 2]" class="placeholder-text placeholder-text--pdp-offer-item-rate"></span>
    </div>
    <div class="pdp-offer-placeholder__bottom">
      <span class="placeholder-text placeholder-text--pdp-offer-fees"></span>
      <span class="placeholder-text placeholder-text--button placeholder-text--listing-btn-redesigned"></span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpOffer">
  <div class="pdp-offer-placeholder pdp-offer-placeholder--desktop">
    <div class="pdp-offer-placeholder__gallery">
      <span class="placeholder-text placeholder-text--pdp-offer-item-img"></span>
    </div>

    <div class="pdp-offer-placeholder__content">
      <div class="pdp-offer-placeholder__content-first">
        <span class="placeholder-text placeholder-text--pdp-offer-title"></span>
        <span class="placeholder-text placeholder-text--pdp-offer-item-title"></span>
        <span class="placeholder-text placeholder-text--pdp-offer-item-places"></span>
        <span class="placeholder-text placeholder-text--pdp-offer-item-title"></span>
        <span class="placeholder-text placeholder-text--pdp-offer-item-places"></span>
        <!--        <div class="pdp-offer-placeholder__amenities">-->
        <!--          <span-->
        <!--            class="placeholder-text placeholder-text&#45;&#45;pdp-offer-item-amenities"-->
        <!--            *ngFor="let item of [1, 2, 3, 4]"-->
        <!--          ></span>-->
        <!--        </div>-->
      </div>
      <div class="pdp-offer-placeholder__content-second">
        <div>
          <span class="placeholder-text pdp-offer-placeholder__content-second-text-1"></span>
          <span class="placeholder-text pdp-offer-placeholder__content-second-text-2"></span>
        </div>
        <span class="placeholder-text placeholder-text--button placeholder-text--listing-btn"></span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpOfferPriceLoading">
  <div class="pdp-offer-placeholder pdp-price-placeholder--desktop">
    <div class="pdp-offer-placeholder__content-second">
      <div>
        <span class="placeholder-text pdp-price-placeholder__content-second-text-1"></span>
        <span class="placeholder-text pdp-price-placeholder__content-second-text-2"></span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpOfferRedesigned">
  <div class="pdp-offer-placeholder__units">
    <div class="pdp-offer-placeholder__units-list">
      <span *ngFor="let item of [1, 2, 3, 4, 5, 6]" class="placeholder-text placeholder-text--units-item"></span>
    </div>
    <div class="pdp-offer-placeholder__units-details">
      <span class="placeholder-text placeholder-text--pdp-offer-title-redesigned"></span>
      <div class="pdp-offer-placeholder__gallery-redesigned">
        <span
          *ngFor="let item of [1, 2, 3]"
          class="placeholder-text placeholder-text--pdp-offer-item-img-redesigned"
        ></span>
      </div>
      <span class="placeholder-text placeholder-text--pdp-offer-item-places"></span>
      <div class="pdp-offer-placeholder__rates">
        <span *ngFor="let item of [1, 2]" class="placeholder-text placeholder-text--pdp-offer-item-rate"></span>
      </div>
      <div class="pdp-offer-placeholder__bottom">
        <span class="placeholder-text placeholder-text--pdp-offer-fees"></span>
        <span class="placeholder-text placeholder-text--button placeholder-text--listing-btn-redesigned"></span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.home">
  <div class="home-slider-placeholder">
    <div class="site-content">
      <div class="home-slider-placeholder--content">
        <span class="placeholder-text placeholder-text--home-slider-pic"></span>
        <div class="home-slider-placeholder__text">
          <span class="placeholder-text placeholder-text--home-slider-title"></span>
          <div class="home-slider-placeholder__text-item">
            <span
              *ngFor="let item of [0, 1, 2, 3, 4, 5, 6]; let i = index"
              [attr.class]="
                'placeholder-text placeholder-text--home-slider-text ' + 'placeholder-text--home-slider-text-' + i
              "
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bdp">
  <div class="bdp-placeholder">
    <div class="bdp-placeholder__pane">
      <div class="bdp-placeholder__pane-block bdp-placeholder--mobile">
        <span class="placeholder-text placeholder-text--bdp-pane-title"></span>
        <span class="placeholder-text placeholder-text--bdp-pane-name"></span>
        <span class="placeholder-text placeholder-text--bdp-pane-line1"></span>
        <span class="placeholder-text placeholder-text--bdp-pane-line2"></span>
        <span class="placeholder-text placeholder-text--bdp-pane-line1"></span>
        <span class="placeholder-text placeholder-text--bdp-pane-green-line"></span>
      </div>
      <div class="bdp-placeholder__pane-block bdp-placeholder--desktop">
        <span class="placeholder-text placeholder-text--bdp-pane-title placeholder-text--bdp-pane-title-desktop"></span>
        <div *ngFor="let item of [1, 2, 3, 4]; let i = index" class="bdp-placeholder__pane-block-item">
          <div class="bdp-placeholder__pane-block-item-left" [ngClass]="'bdp-placeholder__pane-block-item-left-' + i">
            <span class="placeholder-text placeholder-text--bdp-pane-title"></span>
          </div>
          <div class="bdp-placeholder__pane-block-item-right" [ngClass]="'bdp-placeholder__pane-block-item-right-' + i">
            <span class="placeholder-text placeholder-text--bdp-pane-title"></span>
            <span class="placeholder-text"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="bdp-placeholder__inner">
      <div class="bdp-placeholder__inner-item">
        <span class="placeholder-text placeholder-text--bdp-item-title"></span>
        <span class="placeholder-text placeholder-text--bdp-item-line1"></span>
        <span class="placeholder-text"></span>
        <span class="placeholder-text"></span>
        <span class="placeholder-text"></span>
      </div>
      <div class="bdp-placeholder--mobile">
        <span class="placeholder-text placeholder-text--pdp-offer-item-title"></span>
        <div class="pdp-offer-placeholder__gallery">
          <span *ngFor="let item of [1, 2, 3]" class="placeholder-text placeholder-text--pdp-offer-item-img"></span>
        </div>
        <span class="placeholder-text placeholder-text--pdp-offer-item-places"></span>
        <span *ngFor="let item of [1, 2]" class="placeholder-text"></span>
      </div>
      <div class="bdp-placeholder--desktop">
        <span class="placeholder-text placeholder-text--pdp-offer-item-title"></span>
        <div class="bdp-placeholder__gallery">
          <span *ngFor="let item of [1, 2, 3, 4]" class="placeholder-text placeholder-text--bdp-item-img"></span>
        </div>
        <div class="pdp-offer-placeholder__content">
          <div>
            <span class="placeholder-text placeholder-text--pdp-offer-item-title"></span>
            <span class="placeholder-text placeholder-text--pdp-offer-item-places"></span>
            <div class="pdp-offer-placeholder__amenities">
              <span
                *ngFor="let item of [1, 2, 3, 4, 5, 6, 7]"
                class="placeholder-text placeholder-text--pdp-offer-item-amenities"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.checkIn">
  <div class="checkin-placeholder">
    <div class="checkin-placeholder--personal-details">
      <span class="placeholder-text placeholder-text--checkin-booking-details"></span>
      <span class="placeholder-text placeholder-text--checkin-booking"></span>
      <span class="placeholder-text placeholder-text--checkin-personal-details"></span>
      <span class="placeholder-text placeholder-text--checkin-reset"></span>

      <div class="checkin-placeholder__inputs">
        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-label"></span>
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>

        <div class="checkin-placeholder__inputs--group">
          <span class="placeholder-text placeholder-text--checkin-input"></span>
        </div>
      </div>
    </div>
    <div class="checkin-placeholder--booking-details">
      <div class="checkin-placeholder--booking-details__placeholder">
        <span class="placeholder-text placeholder-text--checkin-booking-details"></span>
        <span class="placeholder-text placeholder-text--checkin-big"></span>
        <span class="placeholder-text placeholder-text--checkin-line"></span>
        <span class="placeholder-text placeholder-text--checkin-big"></span>
        <span class="placeholder-text placeholder-text--checkin-small"></span>
        <span class="placeholder-text placeholder-text--checkin-small"></span>
        <span class="placeholder-text placeholder-text--checkin-line"></span>
        <span class="placeholder-text placeholder-text--checkin-big"></span>
        <span class="placeholder-text placeholder-text--checkin-line"></span>
        <span class="placeholder-text placeholder-text--checkin-big"></span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.elfsight">
  <div class="elfsight-placeholder">
    <span class="elfsight-placeholder__item">
      <i *ngFor="let item of [1, 2, 3, 4, 5]" class="elfsight-placeholder__item-star fas fa-star"></i>
    </span>
    <div class="elfsight-placeholder__loader"></div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.elfsightMinified">
  <div class="elfsight-placeholder">
    <span class="elfsight-placeholder__item">
      <i *ngFor="let item of [1]" class="elfsight-placeholder__item-star-minified fas fa-star"></i>
    </span>
    <div class="elfsight-placeholder__loader"></div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.pdpAddress">
  <span class="placeholder-text placeholder-text--pdp-address"></span>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.checkoutRatePlans">
  <div class="checkout-rate-plans-placeholder">
    <span class="placeholder-text placeholder-text--rate-plan"></span>
    <span class="placeholder-text placeholder-text--rate-plan"></span>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.widgetEdit">
  <div class="widget-edit-placeholders">
    <div class="widget-edit-placeholders-top">
      <span class="placeholder-text placeholder-text--widget-edit-top"></span>
      <span class="placeholder-text placeholder-text--widget-edit-top-btn"></span>
    </div>
    <div class="widget-edit-placeholders-dates">
      <div class="widget-edit-placeholders-dates-item">
        <div class="placeholder-text placeholder-text--widget-edit-date-title"></div>
        <div class="placeholder-text placeholder-text--widget-edit-date"></div>
      </div>
      <div class="widget-edit-placeholders-dates-item">
        <div class="placeholder-text placeholder-text--widget-edit-date-title"></div>
        <div class="placeholder-text placeholder-text--widget-edit-date"></div>
      </div>
    </div>
    <div class="widget-edit-placeholders-guests">
      <div class="placeholder-text placeholder-text--widget-edit-guest-item"></div>
      <div class="placeholder-text placeholder-text--widget-edit-guest-item"></div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bookingCard">
  <div class="booking-card-grid-container">
    <div class="booking-card-placeholder">
      <div class="placeholder-text placeholder-text--booking-card--image"></div>
      <div class="booking-card-placeholder-text-container">
        <div class="placeholder-text placeholder-text--booking-card"></div>
        <div class="placeholder-text placeholder-text--booking-card md"></div>
        <div class="placeholder-text placeholder-text--booking-card sm"></div>
        <div class="placeholder-text--booking-card-specs">
          <div class="placeholder-text placeholder-text--booking-card xs"></div>
          <div class="placeholder-text placeholder-text--booking-card xxs"></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bookingCardGrid">
  <div class="booking-card-grid-container">
    <div *ngFor="let item of [].constructor(4); let i = index" class="booking-card-placeholder">
      <div class="placeholder-text placeholder-text--booking-card--image"></div>
      <div class="booking-card-placeholder-text-container">
        <div class="placeholder-text placeholder-text--booking-card"></div>
        <div class="placeholder-text placeholder-text--booking-card md"></div>
        <div class="placeholder-text placeholder-text--booking-card sm"></div>
        <div class="placeholder-text--booking-card-specs">
          <div class="placeholder-text placeholder-text--booking-card xs"></div>
          <div class="placeholder-text placeholder-text--booking-card xxs"></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bookingWidget">
  <div class="booking-widget">
    <div class="booking-widget-image">
      <div class="placeholder-text placeholder-text--booking-card md"></div>
      <div class="placeholder-text placeholder-text--booking-card sm"></div>
    </div>
    <div class="booking-widget-content">
      <div class="placeholder-text placeholder-text--booking-card-dark md"></div>
      <div class="booking-widget-params">
        <div class="placehloder-text placeholder-text--booking-card-dark sm"></div>
        <div class="placeholder-button"></div>
      </div>
      <div class="booking-widget-dates">
        <div class="booking-widget-date-container">
          <div class="placeholder-text placeholder-text--booking-card-dark sm"></div>
          <span class="placeholder-text placeholder-text--booking-card-dark date"></span>
        </div>
        <div class="booking-widget-date-container">
          <div class="placeholder-text placeholder-text--booking-card-dark sm"></div>
          <span class="placeholder-text placeholder-text--booking-card-dark date"></span>
        </div>
      </div>
      <div class="booking-widget-pricing-container main">
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
      </div>
      <div class="booking-widget-pricing-container">
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
      </div>
      <div class="booking-widget-pricing-container">
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
      </div>
    </div>
    <div class="booking-widget-footer">
      <div class="booking-widget-pricing-container">
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
        <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
      </div>
      <div class="placeholder-text placeholder-text--booking-card-dark"></div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bookingWidgetFooter">
  <div class="booking-widget-footer" style="margin-top: 10px">
    <div class="booking-widget-pricing-container">
      <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
      <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
    </div>
    <div class="placeholder-text placeholder-text--booking-card-dark"></div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bookingWidgetFooterMobile">
  <div class="booking-widget-footer" style="margin: 16px">
    <div class="booking-widget-pricing-container">
      <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
      <div class="placeholder-text placeholder-text--booking-card-dark xs"></div>
    </div>
    <div class="placeholder-text placeholder-text--booking-card-dark"></div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.bookingWidgetMobile">
  <div class="booking-widget-mobile">
    <div class="booking-widget-mobile-img"></div>
    <div class="booking-widget-mobile-content">
      <div class="placeholder-text placeholder-text--booking-card-dark sm"></div>
      <div class="placeholder-text placeholder-text--booking-card-dark md"></div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === placeholderTypes.roomDetails">
  <div class="checkout-room-details-placeholder"></div>
</ng-container>
